<div>
    Are you sure you want to delete this item?
</div>
<div class="full-width split-content">
    <button (click)="destroy($event)" class="left" color="warn" mat-raised-button>Yes</button>
    <button (click)="dismiss()" class="right" mat-raised-button>No</button>
</div>
